// @ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { withDivision } from '@/hooks/usePublicLive';

type Key = 'schedule' | 'scoreboard' | 'standings' | 'brackets' | 'venues';

const LINKS: { key: Key; label: string; path: (slug: string) => string }[] = [
  { key: 'schedule', label: 'Schedule', path: (s) => `/schedule/${s}` },
  { key: 'scoreboard', label: 'Scoreboard', path: (s) => `/scoreboard/${s}` },
  { key: 'standings', label: 'Standings', path: (s) => `/standings/${s}` },
  { key: 'brackets', label: 'Brackets', path: (s) => `/brackets/${s}` },
  { key: 'venues', label: 'Venues', path: (s) => `/venues/${s}` },
];

/**
 * One nav for every public view. The active division travels with the link,
 * so a shared bracket or venue page keeps the division the fan was looking at.
 */
export const PublicEventNav: React.FC<{
  slug: string;
  current: Key;
  division?: string;
}> = ({ slug, current, division = 'all' }) => (
  <div className="flex flex-wrap gap-2">
    {LINKS.filter((l) => l.key !== current).map((l) => (
      <Button key={l.key} asChild variant="outline" size="sm">
        <Link to={withDivision(l.path(slug), division)}>{l.label}</Link>
      </Button>
    ))}
  </div>
);

export default PublicEventNav;
